import React from "react";
import {connect} from 'react-redux'
import {Link} from "react-router-dom";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

//Icons
import MonetizationOn from "@material-ui/icons/MonetizationOn";
import AddIcon from "@material-ui/icons/Add";
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

// core components
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";


import Table from "components/Table/Table.jsx";
import LinearProgress from '@material-ui/core/LinearProgress';
import Checkbox from "components/Checkbox/Checkbox";

//Table actions
import Actions from 'views/Tables/Actions'

//Approve popUp
import ConfirmAlert from 'components/Alert/Confirm'
import ProgressAlert from 'components/Alert/Progress'
import SuccessAlert from 'components/Alert/Success'

//Styles
import buttonsStyle from "assets/jss/material-dashboard-pro-react/views/buttonsStyle.jsx";
import selectStyles from "assets/jss/material-dashboard-pro-react/customSelectStyle";


// Actions
import {
  symbolFilter,
  symbolsFetch,
  symbolRemove,
  fetchAllSymbols
} from 'actions/symbols'
import {symbolGroupsFetch, symbolGroupFilter} from 'actions/symbolGroups'

class List extends React.Component {
  selected=[]
  state = {
    selected: [],
    allSymbols: [],
    filterSymbol: '',
    filterSymbolHold: '',
    previousFilterSize: 10,
  }
  componentWillMount(){
    this.props.fetchAllSymbols().then((res) => {
      this.setState({allSymbols: res.content})
    })

  }
  componentDidMount(){
    this.props.filter({size: 10})
    this.props.fetch()
    this.props.symbolGroupFilter({size: 100000})
    this.props.symbolGroupsFetch()
  }
  searchSymbol(e){
    const value = this.state.filterSymbolHold

    if(value !== '') {
      this.props.filter({size: 100000})
      this.props.fetch().then((x) => {
        this.setState({...this.state, filterSymbol: value.toUpperCase()})
      })
    } else {
      this.props.filter({size: this.state.previousFilterSize})
      this.setState({...this.state, filterSymbol: ''})
      this.props.fetch()
    }
  }
  keyPress(e){
    if(e.key === 'Enter'){
       this.searchSymbol(e)
    }
  }
  changeSymbol(e){
    this.setState({...this.state, filterSymbolHold:e.target.value.toUpperCase()})
  }
  //on choose record
  select(id) {
    let select = []
    if (Array.isArray(id)) 
      select = (this.state.selected.length > 0)
        ? []
        : id
    else if (this.state.selected.indexOf(id) > -1) 
      select = this.state.selected.filter((e) => e !== id)
    else 
      select = this
        .state
        .selected
        .concat(id)
    this.setState({
      ...this.state,
      selected: select
    })
  }
  confirmDelete() {
      if(this.selected.length===0){
        this.props.fetch();
        this.setState({
          ...this.state,
          selected:[],
          alert: <SuccessAlert
            title={`Done!`}
            onConfirm={()=>{this.setState({...this.state,alert:false});}}
          />
        });
        return false;
      }
      this.setState({
        ...this.state,
        alert: <ProgressAlert
        value={100-((this.selected.length*100)/this.state.selected.length)}
        title={`Delete Symbols (${this.state.selected.length-this.selected.length+'/'+this.state.selected.length})`}
        />
      });
      this.props.remove(this.selected[0])
        .then((e)=>{
          this.selected=this.selected.slice(1);
          this.confirmDelete();
        })
  }
  //on choose click delete 
  delete() {
    this.setState({
      ...this.state,
      alert: <ConfirmAlert
        text={`to delete ${this.state.selected.length} symbols \n( ${
          this.state.selected.map(id=>this.props.symbols.list.find(e=>e.symbolId===id).name).join(', ')
        } )`}
        onCancel={()=>this.setState({...this.state,alert:false})}
        onConfirm={()=>{
          this.selected=this.state.selected.slice(0);
          this.confirmDelete();
      }}
      />
    });
  }
  //Filter change for pagination or limitation
  filter(filter){
    this.setState({...this.state,selected:[], previousFilterSize: filter.size ? filter.size :this.state.previousFilterSize})
    this.props.filter({
      ...this.props.symbols.pageable,
      ...filter,
      page: filter.size 
        ? 0 
        : filter.page !== undefined ? filter.page : this.props.symbols.pageable.page
    })
    this.props.fetch()
  }
  render() {
    const {match, symbols, symbolGroups} = this.props;
    const selected = this.state.selected
    return (
      <Card>
        {this.state.alert}
        {
        (!symbols.isFetching)?
        //Top actions (pgination/limit/add/remove/edit)
        <Actions
          onPagination={(page)=>this.filter({page:page-1})}
          limit={symbols.pageable.size}
          limitOptions={[10,100,200]}
          onLimitation={(page)=>this.filter({size:page})}
          pagination={symbols.pageable.totalPages>1?{
            pages:symbols.pageable.totalPages,
            current:symbols.pageable.page+1,
          }:false}
          title={(selected.length)
            ? this.state.selected.length + ' Selected'
            : ''}
          dark={selected.length>0}
          icon={<MonetizationOn />}
          actions={{
          add: (selected.length===0)
            ? <Link to={`${match.path}/add`}>
                <IconButton>
                  <AddIcon/>
                </IconButton>
              </Link>
            : '',
            delete: (selected.length>0) && this.props.permissions.includes('SYMBOLS_DELETE')
              ? <IconButton onClick={this.delete.bind(this)}><DeleteIcon/></IconButton>
              : '',
            edit: (selected.length===1)
              ? <Link to={`${match.path}/${this.state.selected[0]}`}>
                  <IconButton>
                      <EditIcon/>
                  </IconButton>
                </Link>
              : ''
        }}/>:''}

        <CardBody>
          {/* If is fetching not display table*/}
          {(symbols.isFetching)
            ? <LinearProgress color="primary"/>
            : (<div>
              <GridContainer>
                <GridItem>
                  <div style={{float:'left', display:'block', width:'100%'}}>
                    <input style={{marginTop:'25px', padding:'5px'}}
                      placeholder="Search symbol" value={this.state.filterSymbolHold} onChange={(e)=>this.changeSymbol(e)}
                      onKeyPress={(e) => this.keyPress(e)} onBlur={(e)=>this.searchSymbol(e)} />
                  </div>
                </GridItem>
              </GridContainer>
              
              <Table
                tableHeaderColor="primary"
                sort={symbols.pageable.sort}
                onSort={(e)=>this.filter({sort:{[e]:symbols.pageable.sort[e]==='desc'?'asc':'desc'}}) }
                tableHead={{ 
                    checkbox:<Checkbox props = {{ 
                      onClick:()=>this.select(symbols.list.map(e=>e.symbolId)),
                      checked:this.state.selected.length===symbols.list.length}
                    }/>,
                    /*symbolId:"#",*/ 
                    name:"Name",
                    lotSize:"Lot Size",
                    pipSize:"Pip Size",
                    type: 'Type',
                    groupId: 'Symbol Group',
                    parentSymbolId: "Base Symbol (Contract)"
                  }}
                tableData={symbols.list.filter(x=> x.name.toUpperCase().includes(this.state.filterSymbol)).map((e,i) => {
                  let baseSymbol = this.state.allSymbols.find((x) => x.symbolId === e.parentSymbolId)
                  let symbolGroup = symbolGroups.find((x) => e.groupId === x.symbolGroupId)
                  return [ 
                    <Checkbox props = {{ onClick:()=>this.select(e.symbolId), checked:this.state.selected.indexOf(e.symbolId)>-1 }}/>,
                    /*e.symbolId,*/ 
                    e.name,
                    e.lotSize,
                    e.pipSize,
                    e.type,
                    symbolGroup ? symbolGroup.name : '',
                    baseSymbol ? baseSymbol.name : ''
                  ]} )}/>
            </div>)}
        </CardBody>
       { 
         symbols.list.length>20
        ?<Actions
            onPagination={(page)=>this.filter({page:page-1})}
            pagination={symbols.pageable.totalPages>1?{
              pages:symbols.pageable.totalPages,
              current:symbols.pageable.page+1,
            }:false}
        />:''}
      </Card>
    );
  }
}
const mapStateToProps = (state) => ({
  symbols: state.symbols,
  symbolGroups: state.symbolGroups.list,
  permissions: state.auth.permissions
})
const mapDispatchToProps = (dispatch) => ({
  filter: (filter) => dispatch(symbolFilter(filter)),
  fetch: () => dispatch(symbolsFetch()),
  remove: (id) => dispatch(symbolRemove(id)),
  fetchAllSymbols: () => dispatch(fetchAllSymbols()),
  symbolGroupsFetch: () => dispatch(symbolGroupsFetch()),
  symbolGroupFilter: (filter) => dispatch(symbolGroupFilter(filter)),
})
export default withStyles({...buttonsStyle, ...selectStyles})(connect(mapStateToProps, mapDispatchToProps)(List));



// WEBPACK FOOTER //
// ./src/views/Symbols/List.jsx